import { TimetableVersionResourceType } from '../../../types/planung-graphql-client-defs';

export type VersionResourceKey = 'class' | 'teacher' | 'subject' | 'room';

/** Die vier Ressourcen-Arten einer Stundenplan-Version, wie Stores und Seiten sie benennen, als Typ der API. */
export const VERSION_RESOURCE_TYPE: Record<VersionResourceKey, TimetableVersionResourceType> = {
  class: TimetableVersionResourceType.Class,
  teacher: TimetableVersionResourceType.Teacher,
  subject: TimetableVersionResourceType.Subject,
  room: TimetableVersionResourceType.Room,
};
